export default __webpack_public_path__ + "static/media/signin-success.b01451b2.png";